import * as WzCase from './WzCase';
import * as Wz1From from './Wz1Form';
import * as Wz2Form from './Wz2Form';
import * as Wz5Form from './Wz5Form';

export default {
    WzCase, Wz1From, Wz2Form, Wz5Form
}